/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S6_P2Inputs */

const en_guide_json_rest_api_s6_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrapping data in a small envelope is a common pattern for a reason. A top-level object with a data field leaves room to add metadata such as pagination, timestamps, or a request id without disturbing the payload itself. Errors benefit from the same discipline: a consistent shape with a machine-readable code and a human-readable message lets clients handle failures without matching on strings.`)
};

const ko_guide_json_rest_api_s6_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터를 작은 봉투로 감싸는 것이 흔한 패턴인 데는 이유가 있습니다. data 필드를 가진 최상위 객체는 페이로드 자체를 건드리지 않고도 페이지네이션, 타임스탬프, 요청 id 같은 메타데이터를 더할 여지를 남깁니다. 오류도 같은 원칙에서 이득을 봅니다. 기계가 읽을 수 있는 코드와 사람이 읽을 수 있는 메시지를 담은 일관된 형태라면, 클라이언트가 문자열을 대조하지 않고도 실패를 처리할 수 있습니다.`)
};

const ja_guide_json_rest_api_s6_p2 = /** @type {(inputs: Guide_Json_Rest_Api_S6_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを小さな封筒で包むのがよくあるパターンなのには理由があります。data フィールドを持つトップレベルのオブジェクトは、ペイロード自体に手を触れずに、ページネーションやタイムスタンプ、リクエスト id といったメタデータを加える余地を残します。エラーも同じ規律から利益を得ます。機械が読めるコードと人が読めるメッセージを持つ一貫した形なら、クライアントは文字列を照合せずに失敗を扱えます。`)
};

/**
* | output |
* | --- |
* | "Wrapping data in a small envelope is a common pattern for a reason. A top-level object with a data field leaves room to add metadata such as pagination, time..." |
*
* @param {Guide_Json_Rest_Api_S6_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s6_p2 = /** @type {((inputs?: Guide_Json_Rest_Api_S6_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S6_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s6_p2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s6_p2(inputs)
	return ja_guide_json_rest_api_s6_p2(inputs)
});